import React from 'react';
import type { CheckboxOptionType } from 'antd/lib/checkbox/Group';
import { css } from '@emotion/react';
import { legacyOnly, newDesignOnly } from 'constants/themes.constants';
import styled from 'types/theme.types';
import ControlledRadioButtons from 'components/common/form-controlled/controlled-radio-buttons';
import type { UseFormReturnType } from 'hooks/use-form.hook';
import type { VcsModalFormValues } from './access-card/use-connection-modal-access-card-form.hook';

export type BlockRadioButtonProps = {
  options: Array<CheckboxOptionType | string | number>;
  form: UseFormReturnType<VcsModalFormValues>;
};

export const VcsConnectionModalFormAuthenticationTypeButton = ({ options, form }: BlockRadioButtonProps) => (
  <Container>
    <ControlledRadioButtons
      label={{ id: 'templates.add.new.field.authorize.type' }}
      name={'authenticationType'}
      form={form}
      block
      options={options}
      optionType={'button'}
      buttonStyle={'solid'}
    />
  </Container>
);

const Container = styled.div`
  ${legacyOnly(
    theme => css`
      && .ant-radio-button-wrapper-checked {
        border: 1px solid ${theme.vcsPickerSelected};
        color: ${theme.vcsPickerSelected};
        background-color: white;
      }
    `
  )}
  ${newDesignOnly(
    theme => css`
      /* Same trade as the type picker: the accent carries the border, but not the label. --text-action
         is the lime, which measures 1.23:1 on a card against AA's 4.5 - and the literal white was theme-blind, so
         a checked option was a white box on a dark card in dark mode. */
      && .ant-radio-button-wrapper-checked {
        border: ${theme.borderWidth.xs} solid var(--border-action);
        color: var(--text-heading);
        background-color: var(--surface-main-cards);
      }
    `
  )}
`;
